import { storeToRefs } from "pinia";
import { useFavoriteTicketsStore } from "../favorite-tickets-store";
import { watch } from "vue";
import { useNgSession } from "@sazka/ng/ng-session";

export const useFavoriteTickets = () => {
    const ACTIVE_CLASS = "ds-product-card-tag__button--active";
    const store = useFavoriteTicketsStore();
    const { favoriteTicketsIds } = storeToRefs(store);
    const { isLoggedIn } = useNgSession();

    const getCards = () => {
        const cards = document.querySelectorAll("[data-js-hook=ds-product-card-add-favorites]");
        const res = Array.from(cards).map((card) => {
            return {
                id: Number((card as HTMLElement).dataset.gameId),
                element: card,
            };
        });

        return res;
    };

    const cards = getCards();

    cards.forEach((card) => {
        card.element.addEventListener("click", () => {
            store.toggleFavoriteTicket(card.id);
        });
    });

    watch(
        favoriteTicketsIds,
        (newVal) => {
            cards.forEach((card) => {
                if (newVal.includes(card.id)) {
                    card.element.classList.add(ACTIVE_CLASS);
                } else {
                    card.element.classList.remove(ACTIVE_CLASS);
                }
            });
        },
        { immediate: true, deep: true }
    );

    watch(
        isLoggedIn,
        async () => {
            if (isLoggedIn.value) {
                await store.loadFavoriteTickets();
            }
        },
        { immediate: true }
    );

    return {
        cards,
    };
};
